import { IBreadCrumbItem } from '../../components/breadcrumb/breadcrumb';

export class BreadcrumbPresenter {
  parse(data: Array<any>): Array<IBreadCrumbItem> {
    return data?.map(v => <IBreadCrumbItem>{ label: v.text, url: v.url.path });
  }
}
